import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {postTicketAPi, postTicketReservedSeatsApi} from "../../api/backendAPIs";

export const postTicket = createAsyncThunk('postTicket', async (payload) => {
    return postTicketAPi(payload);
})

export const postTicketSeats = createAsyncThunk('postTicketSeats', async (payload) => {
    return postTicketReservedSeatsApi(payload);
})

const initialState = {
    reservedSeats: [],
    ticket: null,
    loadingTickets: false,
}

export const ticketSlice = createSlice({
    name: 'trips',
    initialState,
    reducers: {},
    extraReducers: {
        [postTicket.pending]: (state) => {
            state.loadingTickets = true;
        },
        [postTicket.fulfilled]: (state, action) => {
            state.loadingTickets = false;
            state.ticket = action.meta.arg
        },
        [postTicket.rejected]: (state) => {
            state.loadingTickets = false;
        },
        [postTicketSeats.pending]: (state) => {
            state.loadingTickets = true;
        },
        [postTicketSeats.fulfilled]: (state, action) => {
            state.loadingTickets = false;
            state.reservedSeats = action.meta.arg
        },
        [postTicketSeats.rejected]: (state) => {
            state.loadingTickets = false;
        },
    }
});

export const ticketsReducer = ticketSlice.reducer
